module.exports = __webpack_public_path__ + "static/media/settings-icon.216ba0fe.svg";